import { Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { DataSharingService } from '../core/data-sharing.service';
import { PageHeaderService } from '../shared/services/page-header.service';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { TransactionsPage } from '../pages/transactions/transactions.page';
import { Notification } from '../shared/models/notification.model';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
  standalone: false,
  encapsulation: ViewEncapsulation.None
})
export class MainLayoutComponent implements OnInit, OnDestroy {
  defaultDescription = environment.pageHeaders.dashboard.description;
  title = '';
  description = '';
  @Input() selectedAccount: string = '';

  isDarkMode = false;
  paletteToggle = false;

  userProfile: any;
  isSidebarCollapsed = false;
  onSidebarToggled(collapsed: boolean) {
    this.isSidebarCollapsed = collapsed;
  }

  isMobSidebarVisible = false;   // for mobile
  toggleMobileSidebar() {
    console.log('Toggling mobile sidebar. Current state:', this.isMobSidebarVisible);
    this.isMobSidebarVisible = !this.isMobSidebarVisible;
  }

  // Notification Bar
  isNotificationBarCollapsed = false;
  unreadCount: number = 0;
  private subscriptions = new Subscription();

  toggleNotificationBar() {
    this.isNotificationBarCollapsed = !this.isNotificationBarCollapsed;
  }

  onUnreadCountChanged(count: number) {
    //this.unreadCount = count;
  }

  constructor(
    private router: Router,
    private headerService: PageHeaderService,
    private dataSharingService: DataSharingService
  ) {
    // begin:: Subscribe to header updates from the PageHeaderService
    this.headerService.header$.subscribe(data => {
      this.title = data.title;
      this.description = data.description;
    });
    // end:: Subscribe to header updates from the PageHeaderService

  }

  onPageActivate(componentRef: any) {
    console.log('Activated component:', componentRef);
    if (componentRef instanceof TransactionsPage) {
      componentRef.accountChanged.subscribe((acc: string) => {
        this.selectedAccount = acc;
        console.log('Selected Account in MainLayoutComponent:', this.selectedAccount);
      });
    }
  }

  isDashboard(): boolean {
    return this.router.url === '/dashboard';
  }

  isTransactions(): boolean {
    return this.router.url === '/transactions';
  }

  ngOnInit() {
    console.log('MainLayoutComponent initialized');
    this.dataSharingService.getUserProfile().subscribe((res) => {
      this.userProfile = res.data.user;
    });

    // Subscribe to notifications and calculate unread count dynamically
    this.subscriptions.add(
      this.dataSharingService.notifications$.subscribe((notifications: Notification[]) => {
        // Count notifications where read === false
        const newUnreadCount = notifications.filter(notification => !notification.read).length;
        this.unreadCount = newUnreadCount;
        console.log('Unread count updated:', this.unreadCount, 'from', notifications.length, 'notifications');
      })
    );

    const prefersDark = window.matchMedia('(prefers-color-scheme: light)');
    this.initializeDarkPalette(prefersDark.matches);

    // Listen for changes to the prefers-color-scheme media query
    prefersDark.addEventListener('change', (mediaQuery) => this.initializeDarkPalette(mediaQuery.matches));

  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }


  initializeDarkPalette(isDark: boolean) {
    this.paletteToggle = isDark;
    this.toggleDarkPalette(isDark);
  }

  // Listen for the toggle check/uncheck to toggle the dark palette
  toggleChange(event: any) {
    console.log('Toggle changed:', event.detail.checked);
    this.isDarkMode = !this.isDarkMode;
    this.paletteToggle = event.detail.checked;
    this.toggleDarkPalette(event.detail.checked);
  }

  // Add or remove the "ion-palette-dark" class on the html element
  toggleDarkPalette(shouldAdd: boolean) {
    document.documentElement.classList.toggle('ion-palette-dark', shouldAdd);
    document.body.classList.toggle('darkMode', this.isDarkMode);
  }

  ionViewWillEnter() {
    console.log('MainLayoutComponent: ionViewWillEnter called');
  }
  ionViewDidEnter() {
    console.log('MainLayoutComponent: ionViewDidEnter called');
  }

  // toggleTheme() {
  //   this.isDarkMode = !this.isDarkMode;
  //   document.body.classList.toggle('dark', this.isDarkMode);
  // }
}
